"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuToggleRoot = void 0;
var _mui = require("@ori-ui/mui");
const BurgerMenuToggleRoot = exports.BurgerMenuToggleRoot = (0, _mui.styled)('div')({
  position: 'relative'
});
